import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/main',
    component: () => import('../components/main/MainForm.vue')
  },
  {
    path: '/attendanceEvent',
    component: () => import('../components/community/event/AttendanceCheckEvent.vue')
  },
  {
    path: '/community',
    component: () => import('../components/community/CommunityForm.vue')
  },
  {
    path: '/community_view',
    component: () => import('../components/community/CommunityViewForm.vue')
  },
  {
    path: '/community_write',
    component: () => import('../components/community/CommunityWriteForm.vue')
  },
  {
    path: '/community_modify',
    component: () => import('../components/community/CommunityModifyForm.vue')
  },
  {
    path: '/mining',
    component: () => import('../components/mining/MiningForm.vue')
  },
  {
    path: '/mining_detail',
    component: () => import('../components/mining/MiningDetail.vue')
  },
  {
    path: '/mining_guide',
    component: () => import('../components/mining/MiningGuideForm.vue')
  },
  {
    path: '/roulette',
    component: () => import('../components/mining/game/Roulette.vue')
  },
  {
    path: '/dice',
    component: () => import('../components/mining/game/DiceForm.vue')
  },
  {
    path: '/slotmachine',
    component: () => import('../components/mining/game/SlotMachineForm.vue')
  },
  {
    path: '/luckycard',
    component: () => import('../components/mining/game/LuckyCardForm.vue')
  },
  {
    path: '/more',
    component: () => import('../components/more/MoreForm.vue')
  },
  {
    path: '/invite',
    component: () => import('../components/more/InviteForm.vue')
  },
  {
    path: '/event',
    component: () => import('../components/event/EventForm.vue')
  },
  {
    path: '/upcomingEvent',
    component: () => import('../components/event/UpcomingEventForm.vue')
  },
  {
    path: '/ongoingEvent',
    component: () => import('../components/event/OngoingEventForm.vue')
  },
  {
    path: '/endedEvent',
    component: () => import('../components/event/EndedEventForm.vue')
  },
  {
    path: '/attendanceList',
    component: () => import('../components/event/common/EventAttendanceListForm.vue')
  },
  {
    path: '/winnerList',
    component: () => import('../components/event/common/EventWinnerListForm.vue')
  },
  {
    path: '/ongoingLotto',
    component: () => import('../components/event/OngoingLottoForm.vue')
  },
  {
    path: '/lottoAttandanceList',
    component: () => import('../components/event/lotto/LottoAttendanceListForm.vue')
  },
  {
    path: '/lottoMyJoinList',
    component: () => import('../components/event/lotto/LottoMyJoinListForm.vue')
  },
  {
    path: '/lottoMyPrevJoinList',
    component: () => import('../components/event/lotto/LottoMyPrevJoinListFrom.vue')
  },
  {
    path: '/lottoWinnerList',
    component: () => import('../components/event/lotto/LottoWinnerListForm.vue')
  },
  {
    path: '/notice',
    component: () => import('../components/more/NoticeForm.vue')
  },
  {
    path: '/noticeDetail',
    component: () => import('../components/more/NoticeDetailForm.vue')
  },
  {
    path: '/help',
    component: () => import('../components/more/HelpForm.vue')
  },
  {
    path: '/setting',
    component: () => import('../components/more/SettingForm.vue')
  },
  {
    path: '/party_list',
    component: () => import('../components/myInfo/AddPartyForm.vue')
  },
  {
    path: '/coupon',
    component: () => import('../components/myInfo/CouponForm.vue')
  },
  {
    path: '/order_list',
    component: () => import('../components/myInfo/OrderListForm.vue')
  },
  {
    path: '/level_info',
    component: () => import('../components/myInfo/LevelInfoForm.vue')
  },
  {
    path: '/trophy',
    component: () => import('../components/myInfo/TrophyForm.vue')
  },
  {
    path: '/myLike',
    component: () => import('../components/myInfo/MyLikeListForm.vue')
  },
  {
    path: '/myPost',
  component: () => import('../components/myInfo/MyPostForm.vue')
  },
  {
    path: '/myReply',
    component: () => import('../components/myInfo/MyReplyForm.vue')
  },
  {
    path: '/gate',
    component: () => import('../components/common/GateForm.vue')
  },
  {
    path: '/termsDetail',
    component: () => import('../components/more/common/TermsDetailForm.vue')
  },
  {
    path: '/termsList',
    component: () => import('../components/more/common/TermsListForm.vue')
  },
  {
    path: '/partnershipInquiry',
    component: () => import('../components/more/PartnershipInquiryForm.vue')
  },
  {
    path: '/limitedUser',
    component: () => import('../components/common/LimitedUser.vue')
  },
  {
    path: '/nftForm',
    component: () => import('../components/nft/NftForm.vue')
  },
  {
    path: '/pointList',
    component: () => import('../components/nft/PointListForm.vue')
  },
  {
    path: '/purchase',
    component: () => import('../components/nft/PurchaseForm.vue')
  },
  {
    path: '/purchaseList',
    component: () => import('../components/nft/PurchaseListForm.vue')
  },
  {
    path: '/payment',
    component: () => import('../components/nft/PaymentForm.vue')
  },
  {
    path: '/maintenance',
    component: () => import('../components/maintenance/Maintenance.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router